import React, { useState, useEffect, useRef } from 'react';
import { useForm } from 'react-hook-form';
import { Auth } from 'aws-amplify';
import { addMinutes } from 'date-fns';
import { Link, useLocation } from 'react-router-dom';
import { AuthLayout } from '../../layouts/AuthLayout';
import {
    useNotify,
    useTranslate,
    useRedirect,
    useAuthProvider,
    useDataProvider,
} from 'react-admin';
import {
    Input,
    Button,
    CircularProgress,
    Typography,
    Box,
    makeStyles,
} from '@material-ui/core';
import { LoaderApp } from "../../components/layout/LoaderApp";

const useStyles = makeStyles((theme) => ({
    title: {
        color: '#2D4050',
        fontWeight: 'bold',
        marginBottom: 5,
        textAlign: 'center',
    },
    contentText: {
        color: '#888888',
        fontWeight: 'normal',
        fontSize: 16,
        margin: 0,
        marginBottom: 25,
        textAlign: 'center',
    },
    linkPassword: {
        textDecoration: 'none',
        cursor: 'pointer',
        fontWeight: 'bold',
        color: (props) => (props.resendEnabled ? '#00205B' : '#A0A0A0'),
        pointerEvents: (props) => (props.resendEnabled ? 'auto' : 'none'),
    },
    timerText: {
        color: '#00205B',
        marginTop: '20px',
    },
}));

const VerifyOtp = () => {
    const translate = useTranslate();
    const notify = useNotify();
    const location = useLocation();
    const redirect = useRedirect();
    const [timeLeft, setTimeLeft] = useState(180);
    const [resendEnabled, setResendEnabled] = useState(false);
    const [btnSubmit, setBtnSubmit] = useState(true);
    const classes = useStyles({ resendEnabled });
    const { register, handleSubmit, watch } = useForm();
    const otpFieldRef = useRef(null);
    const [loading, setLoading] = useState(false);

    const handleResendCodeOtp = async () => {
        setLoading(true)
        if (location.state) {
            const { username, password } = location.state;
            Auth.signOut();
            const auth = await Auth.signIn(username, password);
            notify(translate('ra.auth.success_resend_otp'), {
                type: 'success',
                autoHideDuration: 3000,
            });
            location.state = { username, password, auth };
            Auth.signOut();
            location.state = { username: username, password: password, auth: auth }
            setTimeLeft(180);
            setResendEnabled(false);
            if (otpFieldRef.current.value || otpFieldRef.current.value != null)
                otpFieldRef.current.value = '';
            //redirect("/verify-otp", "", undefined, undefined, { username: username, password: password, auth: auth})
            setLoading(false)
        } else {
            notify(translate('ra.auth.error_resend_otp'), 'warning');
            //redirect('/login')
        }
    };

    const handleSubmitOtp = async (data) => {
        setBtnSubmit('loading');
        console.log(location.state);
        if (location.state) {
            const { username, password, auth } = location.state;
            try {
                const dataResend = await Auth.sendCustomChallengeAnswer(
                    auth,
                    data.otpField
                );
                if (!dataResend.attributes && !dataResend.attributes['custom:pin_bancaribe']) {
                    redirect(
                        '/change-password-temp',
                        '',
                        undefined,
                        undefined,
                        { username, password, auth: dataResend }
                    );
                    return;
                }
                if (dataResend.signInUserSession !== null) {
                    const totalExpirationDate =
                        Number(dataResend.attributes['custom:password_update']) +
                        Number(dataResend.attributes['custom:password_expiry_time']);
                    let currentDate = new Date().getTime();
                    if (currentDate < totalExpirationDate) {
                        let newSessionTime = addMinutes(new Date(), 10);
                        window.localStorage.setItem(
                            'sessionTime',
                            newSessionTime
                        );
                        if (dataResend.attributes['custom:role'] !== 'Root') {
                            window.localStorage.setItem(
                                'businessIdSelected',
                                dataResend.attributes['custom:business']
                            );
                        }
                        if (
                            dataResend.attributes['custom:role'] !== 'Root' &&
                            dataResend.attributes['custom:role'] !== 'Admin'
                        ) {
                            window.localStorage.setItem(
                                'branchIdSelected',
                                dataResend.attributes['custom:branch_id']
                            );
                            window.localStorage.setItem(
                                'email',
                                dataResend.attributes['email']
                            );
                        }
                        setBtnSubmit(true);
                        redirect('/login');
                    } else {
                        redirect(
                            '/change-password-temp',
                            '',
                            undefined,
                            undefined,
                            { username, password, auth: dataResend }
                        );
                    }
                } else {
                    notify(
                        translate('ra.notification.otp_not_equeals'),
                        'warning'
                    );
                    setBtnSubmit(true);
                }
            } catch (err) {
                console.error('Auth.confirmSignIn(): ', err.message);
                if (err.message === 'Invalid session for the user.') {
                    notify(translate('ra.notification.otp_expired'), 'warning');
                } else {
                    notify(
                        translate('ra.notification.otp_not_equeals'),
                        'warning'
                    );
                }
                setBtnSubmit(true);
            }
        } else {
            notify('ra.notification.otp_not_found', 'warning');
            setBtnSubmit(true);
        }
    };

    useEffect(() => {
        if (timeLeft > 0) {
            const timerId = setInterval(() => {
                setTimeLeft((prevTime) => prevTime - 1);
            }, 1000);
            return () => clearInterval(timerId);
        } else {
            setResendEnabled(true);
        }
    }, [timeLeft]);

    return (
        <>
            {
                btnSubmit === 'loading' && (
                    <LoaderApp />
                )
            }
            <AuthLayout>
                <form
                    style={{ width: '95%', maxWidth: 410 }}
                    onSubmit={handleSubmit(handleSubmitOtp)}
                >
                    <Typography variant="h5" className={classes.title}>
                        {translate('ra.auth.title_otp')}
                    </Typography>
                    <Typography
                        style={{
                            color: '#2e2e2e',
                            marginTop: '20px',
                            marginBottom: '20px',
                        }}
                    >
                        {translate('ra.notification.enter_otp')}
                    </Typography>
                    <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        gridGap="22px"
                        width="100%"
                        margin="0 auto"
                        marginTop="20px"
                        maxWidth="410px"
                    >
                        <Input
                            fullWidth
                            placeholder={translate('ra.auth.otpField')}
                            type="password"
                            style={{ padding: '22px 28px' }}
                            {...register('otpField', { required: true })}
                            disableUnderline={true}
                            required={true}
                            inputRef={otpFieldRef}
                        />
                        {timeLeft > 0 && (
                            <Typography variant="body1" className={classes.timerText}>
                                {`${translate(
                                    'ra.notification.resend_otp_in'
                                )} ${timeLeft} ${translate('ra.notification.seconds')}`}
                            </Typography>
                        )}
                        <Box
                            width="100%"
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                        >
                            {loading ? (
                                <CircularProgress size={24} />
                            ) : (
                                <a
                                    onClick={handleResendCodeOtp}
                                    className={classes.linkPassword}
                                >
                                    <Typography variant="body1">
                                        {translate('ra.notification.resend_otp')}
                                    </Typography>
                                </a>
                            )}
                        </Box>
                        <Button
                            fullWidth
                            type="submit"
                            variant={
                                btnSubmit === 'loading' ? 'outlined' : 'contained'
                            }
                            color="primary"
                            style={{
                                margin: 55,
                                marginBottom: 16,
                                borderRadius: '10px',
                            }}
                            size="large"
                            disabled={
                                watch('otpField') === undefined ||
                                watch('otpField') === ''
                            }
                        >
                            {btnSubmit === 'loading' ? (
                                <CircularProgress
                                    color="primary"
                                    size="1.5rem"
                                />
                            ) : (
                                translate('ra.action.continue')
                            )}
                        </Button>
                        <Link
                            to="/login"
                            style={{ width: '100%', textDecoration: 'none' }}
                        >
                            <Button
                                fullWidth
                                variant="outlined"
                                color="inherit"
                                size="large"
                            >
                                {translate('ra.action.goBack')}
                            </Button>
                        </Link>
                    </Box>
                </form>
            </AuthLayout>


        </>

    );
};

export default VerifyOtp;
